import React, { useState, useEffect, useRef } from 'react';
import {
    FormControl,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    Button,
    OutlinedInput,
    DialogActions,
    DialogContent,
    DialogTitle,

} from '@mui/material';
import axios from '../../../../utils/fvAxios';
import apiinfo from '../../../../utils/base-uri.json';
import { useForm } from 'react-hook-form';
import BaseURL from "../../../../utils/base-uri.json";
import { getGlobalClientId, getToken, getOrgType, getOrgId } from "../../../../utils/Token";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { TextField, Stack, ListSubheader } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export default function EmployeeCheckInHistory({ close, name }) {
    const [client, setClient] = React.useState([]);
    const [error, setError] = useState(null);
    const { register } = useForm();
    const [token, setToken] = useState(getToken())
    const [isLoading, setIsLoading] = useState(true);
    const [VendorId, setVendorId] = useState(getOrgType() == "Vendor" ? getOrgId() : null)

    useEffect(() => {
        if (getOrgType() != "Vendor") {
            axios
                .get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false&ClientIds=" +
                    getGlobalClientId())
                .then((res) => {
                    if (res.data.responseCode === 100) {
                        if (getOrgType() == "Client") {
                            changeClients(res?.data?.data[0]?.value)
                        }
                        setClient(res.data.data);
                    } else {
                        setError(res.data.responseMessage);
                    }
                })
                .catch((err) => {
                    console.log(err);
                }).finally(() => {
                    setIsLoading(false);
                });
        } else {
            axios
                .get("Employee/GetVendorClientFileInfo?VendorId=" + getOrgId())
                .then((resp) => {
                    if (resp.data.responseCode === 100) {
                        setClient(
                            resp.data.data.map(({ clientName, clientID, ...rest }) => ({
                                ...rest,
                                text: clientName,
                                value: clientID
                            }))
                        );
                    } else {
                        setError(resp.data.responseMessage);
                    }
                })
                .catch((err) => {
                    console.log(err);
                }).finally(() => {
                    setIsLoading(false);
                });
        }
    }, []);

    const ITEM_HEIGHT = 50;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
                width: 200,
            },
        },
    };

    const date = new Date();
    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    const [fromDateValue, setFromDateValue] = useState(formatDate(date));
    const [toDateValue, setToDateValue] = useState(formatDate(date));
    const [ClientId, setClientId] = useState("");

    const [ClientBusinessUnitSites, setClientBusinessUnitSites] = useState([]);
    const [ClientBusinessUnitSiteIds, setClientBusinessUnitSiteIds] = useState([]);

    const [dateError, setDateError] = useState("");

    const handleDateKeyDown = (e) => {
        e.preventDefault();
    };

    const validateDates = (fromDate, toDate) => {

        if (!fromDate || !toDate) {
            setDateError("");
            return true;
        }

        const from = new Date(fromDate);
        from.setHours(0, 0, 0, 0);

        const to = new Date(toDate);
        to.setHours(0, 0, 0, 0);

        // Validation 1:
        // To Date should not be less than From Date.
        // Same date is allowed.
        if (to < from) {
            setDateError("To Date cannot be earlier than From Date.");
            return false;
        }

        // Validation 2:
        // Date range should not exceed one year.
        const maxToDate = new Date(from);
        maxToDate.setFullYear(maxToDate.getFullYear() + 1);

        if (to > maxToDate) {
            setDateError("The date range should not exceed one year.");
            return false;
        }

        setDateError("");
        return true;
    };

    const handleFromDateChange = (event) => {

        const selectedDate = formatDate(event);
        setFromDateValue(selectedDate);

        validateDates(selectedDate, toDateValue);
    };

    const handleToDateChange = (event) => {

        const selectedDate = formatDate(event);
        setToDateValue(selectedDate);

        validateDates(fromDateValue, selectedDate);
    };

    const changeClients = (e) => {
        setClientId(e);
        axios.get("Companies/GetClientBusinessUnitSites?clientId=" + e
        ).then((res) => {
            if (res?.data?.responseCode === 100) {
                setClientBusinessUnitSites(res?.data?.data?.item3);
            }
        }).catch(err => {
            console.log(err)
        })
    };

    const groupedSites = ClientBusinessUnitSites?.reduce((acc, site) => {
        if (!acc[site.businessUnitName]) {
            acc[site.businessUnitName] = [];
        }
        acc[site.businessUnitName].push(site);
        return acc;
    }, {});


    const menuListRef = useRef(null);
    const handleMenuOpen = () => {
        scrollToTopOfOtions();
    };
    const scrollToTopOfOtions = () => {
        setTimeout(() => {
            if (menuListRef.current) {
                const children = menuListRef.current.children;
                if (children.length >= 2) {
                    const secondLastOption = children[children.length - 2];
                    if (secondLastOption) {
                        secondLastOption.scrollTop = 0;
                    }
                }
            }
        }, 5);
    };

    return (
        <>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <DialogTitle id="alert-dialog-title">{name}</DialogTitle>
            <DialogContent>
                <form
                    action={
                        BaseURL?.baseReportUrl + 'EmployeeCheckInHistory.aspx'
                    }
                    method="post"
                    target="_blank"
                >
                    <div style={{ marginLeft: '20px' }}>
                        {dateError && <span className='text-danger mx-1'>{dateError}</span>}
                        <FormControl sx={{ m: 1, width: 320 }}>
                            <span
                                style={{
                                    color: '#3E4A62',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    marginTop: '5px',
                                    marginBottom: '5px',
                                }}
                            >
                                From
                                <span style={{ color: "red" }}> *</span>
                            </span>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    views={["year", "month", "day"]}
                                    value={fromDateValue || ''}
                                    onChange={handleFromDateChange}
                                    name="fromDate"
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            sx={{
                                                "& legend": { display: "none" },
                                                "& fieldset": { top: 0 },
                                                width: "320px",
                                            }}
                                            size="small"
                                            name="fromDate"
                                            onKeyDown={handleDateKeyDown}
                                        />
                                    )}
                                />
                            </LocalizationProvider>

                            <span
                                style={{
                                    color: '#3E4A62',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    marginTop: '5px',
                                    marginBottom: '5px',
                                }}
                            >
                                To
                                <span style={{ color: "red" }}> *</span>
                            </span>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    views={["year", "month", "day"]}
                                    value={toDateValue || ''}
                                    name="toDate"
                                    onChange={handleToDateChange}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            sx={{
                                                "& legend": { display: "none" },
                                                "& fieldset": { top: 0 },
                                                width: "320px",
                                            }}
                                            name="toDate"
                                            size="small"
                                            onKeyDown={handleDateKeyDown}
                                        />
                                    )}
                                />
                            </LocalizationProvider>


                            <span
                                style={{
                                    color: "#3E4A62",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    marginTop: "5px",
                                    marginBottom: "5px",
                                }}
                            >
                                Client
                                <span style={{ color: "red" }}> *</span>
                            </span>
                            <Select
                                labelId="demo-multiple-name-label"
                                id="demo-multiple-name"
                                {...register("client")}
                                sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                    fontFamily: "Arial, FontAwesome",
                                }}
                                size="small"
                                name="clientIds"
                                onChange={(e) => changeClients(e.target.value)}
                                input={
                                    <OutlinedInput label="Select Client" value={ClientId} />
                                }
                                MenuProps={MenuProps}
                            >
                                {client.map((item, index) => (
                                    <MenuItem key={index} title={item?.text} value={item?.value}>
                                        {item?.text}
                                    </MenuItem>
                                ))}
                            </Select>

                            <span
                                style={{
                                    color: "#3E4A62",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    marginTop: "5px",
                                    marginBottom: "5px",
                                }}
                            >
                                Sites
                                <span style={{ color: "red" }}> *</span>
                            </span>

                            <Select
                                multiple
                                MenuProps={MenuProps}
                                name="ClientBusinessUnitSiteIds"
                                size="small"
                                sx={{ width: "320px", overflow: "hidden" }}
                                value={ClientBusinessUnitSiteIds || []}
                                onChange={(e) => setClientBusinessUnitSiteIds(e.target.value)}
                                renderValue={(selected) =>
                                    selected
                                        .map(
                                            (id) =>
                                                ClientBusinessUnitSites?.find((s) => s.businessUnitSiteID === id)
                                                    ?.businesUnitsiteName
                                        )
                                        .filter(Boolean)
                                        .join(", ")
                                }
                            >
                                {/* Select All */}
                                <MenuItem key="select-all" hidden={ClientBusinessUnitSites?.length === 0}>
                                    <Checkbox
                                        id="select-all-sites-checkbox"
                                        indeterminate={
                                            (ClientBusinessUnitSiteIds || []).length > 0 &&
                                            (ClientBusinessUnitSiteIds || []).length < ClientBusinessUnitSites?.length
                                        }
                                        checked={
                                            ClientBusinessUnitSites?.length > 0 &&
                                            (ClientBusinessUnitSiteIds || []).length === ClientBusinessUnitSites?.length
                                        }
                                        onChange={(event) => {
                                            if (event.target.checked) {
                                                setClientBusinessUnitSiteIds(ClientBusinessUnitSites?.map((s) => s.businessUnitSiteID) || []);
                                            } else {
                                                setClientBusinessUnitSiteIds([]);
                                            }
                                        }}
                                    />
                                    <label
                                        htmlFor="select-all-sites-checkbox"
                                        style={{
                                            fontSize: 16,
                                            fontWeight: 500,
                                            color: "rgba(0, 0, 0, 0.87)",
                                            width: "320px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Select All
                                    </label>
                                </MenuItem>

                                {/* Grouped Options */}
                                {Object.entries(groupedSites)?.flatMap(([groupName, sites]) => [
                                    <ListSubheader
                                        key={`header-${groupName}`}
                                        sx={{
                                            lineHeight: "22px",
                                            color: "#fff",
                                            backgroundColor: "#b9b3b3",
                                            position: "sticky",
                                            top: 0,
                                            zIndex: 1,
                                        }}
                                    >
                                        {groupName}
                                    </ListSubheader>,

                                    ...sites?.map((site) => (
                                        <MenuItem key={site.businessUnitSiteID} value={site.businessUnitSiteID}>
                                            <Checkbox
                                                checked={(ClientBusinessUnitSiteIds || []).includes(site.businessUnitSiteID)}
                                            />
                                            <ListItemText primary={site.businesUnitsiteName} />
                                        </MenuItem>
                                    )),
                                ])}
                            </Select>

                        </FormControl>
                    </div>
                    <DialogActions>
                        <div className="login-help__buttonContainer">
                            <Button
                                variant="contained"
                                className="login-help-button-cancel"
                                onClick={close}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                className="login-button-request"
                                type="submit"
                                onClick={close}
                                disabled={ClientId == "" || ClientBusinessUnitSiteIds?.length == 0 || dateError}
                            >
                                Create Report
                            </Button>
                        </div>
                    </DialogActions>
                    <input type="hidden" name="token" value={token} />
                    <input type="hidden" name="vendorId" value={VendorId} />
                </form>
                <br />
            </DialogContent>
        </>
    );
}
